import { DWDetailItem } from 'src/components/detail-item';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWDetailItem.displayName, DWDetailItem);

export default DWDetailItem;
export { DWDetailItem };
